






















import { LayoutModule } from "@/store/layout";
import { Component, Vue } from "vue-property-decorator";
import Modal from "./Modal.vue";

@Component({
  components: { Modal },
})
export default class GenericDialog extends Vue {
  get dialogConfig(): any {
    return LayoutModule.getDialog;
  }

  get showDialog(): boolean {
    return LayoutModule.dialogIsVisible;
  }

  close(): void {
    this.dialogConfig.component = null;
    LayoutModule.hideDialog();
  }

  async accept(): Promise<void> {
    await this.dialogConfig.successButton.callback();

    this.dialogConfig.successButton.closeDialog
      ? LayoutModule.hideDialog()
      : null;
  }
}
